import { render } from "./BuyPanel.vue?vue&type=template&id=276372fa&scoped=true&ts=true"
import script from "./BuyPanel.vue?vue&type=script&lang=ts"
export * from "./BuyPanel.vue?vue&type=script&lang=ts"

import "./BuyPanel.vue?vue&type=style&index=0&id=276372fa&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276372fa"]])

export default __exports__